import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import Swal from 'sweetalert2';
import {Constants} from '../../constants';
import {DataManagementService} from '../../services/data-management.service';
import {AppSettings} from '../../../app-settings';
import {AuthenticationService} from '../../services/authentication.service';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import * as XLSX from 'xlsx';
import {Router} from '@angular/router';

@Component({
    selector: 'app-actions',
    templateUrl: './actions.component.html',
    styleUrls: ['./actions.component.css']
})
export class ActionsComponent implements OnInit {
    @ViewChild('uploadPastDataModal') uploadPastDataModal: TemplateRef<any>;
    public modalReference: NgbModalRef;
    data: object;

    constructor(private modal: NgbModal,
                private dmService: DataManagementService,
                private router: Router,
                private authenticationService: AuthenticationService) {
    }
    downloadPasswords = AppSettings.DOWNLOAD_PASSWORDS;
    token;

    flushAll(): void {
        let flushResponse;
        const that = this;
        Swal({
            title: 'confirm',
            type: 'question',
            text: 'Do you want to Flush all the data?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.clearData(Constants.CLEAR_ALL).subscribe(data => {
                        flushResponse = data;
                        resolve(flushResponse);
                    }, error => {
                        flushResponse = error;
                        reject(flushResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (flushResponse.status === 'success') {
                    Swal({
                        type: 'success',
                        title: 'Success',
                        width: 600,
                        padding: 80,
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: '<p>Successfully flushed all the data.</p>',
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                } else if (flushResponse.status === 'fail') {
                    Swal({
                        type: 'error',
                        title: 'Fail',
                        width: 600,
                        padding: 80,
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: '<p>Unable to flush data. Please contact support team</p>'
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                }
            }
        }, function (cancel) {
            console.log(cancel);
        }).catch(function (error) {
            console.log(error);
        });
    }

    generateRandomPreferences(): void {
        let generateResponse;
        const that = this;
        Swal({
            title: 'confirm',
            type: 'question',
            text: 'Do you want to generate random preferences?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.bulkUpload({}, Constants.GENERATE_PREFERENCES).subscribe(data => {
                        generateResponse = data;
                        resolve(generateResponse);
                    }, error => {
                        generateResponse = error;
                        reject(generateResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (generateResponse.status === 'success') {
                    Swal({
                        type: 'success',
                        title: 'Success',
                        width: 600,
                        padding: 80,
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: '<p>Successfully generated preferences for students.</p>',
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                } else if (generateResponse.status === 'fail') {
                    Swal({
                        type: 'error',
                        title: 'Fail',
                        width: 600,
                        padding: 80,
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: '<p>Unable to generated preferences for students. Please contact support team</p>'
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                }
            }
        }, function (cancel) {
            console.log(cancel);
        }).catch(function (error) {
            console.log(error);
        });
    }

    flushTermSettings(): void {
        Swal({
            title: 'confirm',
            type: 'question',
            text: 'Do you want to Flush Term Settings data?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    resolve(true);
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.value === true) {
                Swal({title: 'Success', type: 'success', text: 'Term Settings flushed successfully.', timer: 1500});
            }
        }, function (cancel) {
            console.log(cancel);
        }).catch(function (error) {
            console.log(error);
        });
    }

    flushRoundSettings(): void {
        Swal({
            title: 'confirm',
            type: 'question',
            text: 'Do you want to Flush Round Settings data?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    resolve(true);
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.value === true) {
                Swal({title: 'Success', type: 'success', text: 'Round Settings flushed successfully.', timer: 1500});
            }
        }, function (cancel) {
            console.log(cancel);
        }).catch(function (error) {
            console.log(error);
        });
    }

    openPastDataUploadModal() {
        this.modalReference = this.modal.open(this.uploadPastDataModal, {size: 'lg', backdrop: 'static', keyboard: false});
    }

    closeModal(): void {
        this.modalReference.close();
    }

    fileChange(evt) {
        const target: DataTransfer = <DataTransfer>(evt.target);
        if (target.files.length !== 1) {
            throw new Error('Cannot upload multiple files on the entry');
        }
        const reader = new FileReader();
        reader.onload = (e: any) => {
            /* read workbook */
            const bstr = e.target.result;
            const wb = XLSX.read(bstr, {type: 'binary'});
            /* grab first sheet */
            const wsName = wb.SheetNames[0];
            const ws = wb.Sheets[wsName];
            /* save data */
            this.data = XLSX.utils.sheet_to_json(ws,
                {header: [ 'outgoing_term_code', 'academic_year', 'programme', 'university_name', 'registration_id',
                        'student_rank', 'change_type'], range: 1});
        };
        reader.readAsBinaryString(target.files[0]);
        return this.data;
    }

    uploadPastData(e) {
    e.preventDefault();
    const that = this;
    let uploadResponse;
    Swal({
      title: 'Confirm',
      type: 'question',
      text: 'You are going to upload ' + Object.keys(this.data).length + ' Past Data?',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-outline-success rounded-0',
      cancelButtonClass: 'btn btn-outline-danger rounded-0',
      cancelButtonColor: '#d33',
      confirmButtonColor: '#4cb84c',
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
      showLoaderOnConfirm: true,
      preConfirm: function () {
        return new Promise(function (resolve, reject) {
          that.dmService.bulkUpload(that.data, Constants.PAST_DATA).subscribe(data => {
            uploadResponse = data;
            resolve(uploadResponse);
          }, error => {
            uploadResponse = error;
            reject(uploadResponse);
          });
        });
      },
      allowOutsideClick: false
    }).then(function (result) {
      console.log(result);
      if (result.hasOwnProperty('value')) {
        if (uploadResponse.status === 'success') {
          that.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then( () =>
              that.router.navigate(['utility/actions']));
          if (uploadResponse.data.hasOwnProperty('message')) {
            Swal({
              title: 'Success',
              type: 'success',
              html: uploadResponse.data.message,
            });
          } else {
            Swal({
              title: 'Success',
              type: 'success',
              html: '<p>Successfully uploaded Past Data.</p>',
            });
          }
          that.closeModal();
        } else if (uploadResponse.status === 'fail') {
          if (uploadResponse.data.hasOwnProperty('message')) {
            Swal({type: 'error', title: 'Fail', html: uploadResponse.data.message});
          } else {
            Swal({type: 'error', title: 'Fail', text: 'Unable to upload Past Data, Please contact support team.'});
          }
        }
      }
    }).catch(errors => {
      Swal({type: 'error', title: 'Fail', text: 'Server Error: ' + errors.message});
    });
  }


    ngOnInit() {
        this.token = '?token=' + this.authenticationService.getToken();
    }

}
